import React from 'react';
import { Container, Paper, Typography, Button, Box } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const VerificationSuccess = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
        <Box sx={{ mb: 3 }}>
          <CheckCircle sx={{ fontSize: 80, color: 'success.main', mb: 2 }} />
          <Typography variant="h3" component="h1" gutterBottom color="success.main">
            Email Verified Successfully!
          </Typography>
        </Box>
        
        <Typography variant="h6" paragraph>
          🎉 Congratulations! Your email address has been verified.
        </Typography>
        
        <Typography variant="body1" paragraph sx={{ mb: 3 }}>
          Your account is now fully activated and you can start using all features of the Short Story Platform:
        </Typography>
        
        <Box sx={{ textAlign: 'left', maxWidth: 400, mx: 'auto', mb: 4 }}>
          <Typography variant="body2" component="div">
            ✍️ Create and publish your stories<br/>
            💬 Comment on other stories<br/>
            👤 Build your author profile<br/>
            🤝 Connect with other writers
          </Typography>
        </Box>
        
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Button 
            variant="contained" 
            size="large"
            onClick={() => navigate('/stories/create')}
            sx={{ minWidth: 200 }}
          >
            Write Your First Story
          </Button>
          <Button 
            variant="outlined" 
            size="large"
            onClick={() => navigate('/stories')}
            sx={{ minWidth: 200 }}
          >
            Browse Stories
          </Button>
        </Box>
        
        <Typography variant="body2" sx={{ mt: 3, color: 'text.secondary' }}>
          Welcome to our community of storytellers!
        </Typography>
      </Paper>
    </Container>
  );
};

export default VerificationSuccess;
